/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { inject, Injectable } from '@angular/core';
import { Resource } from '@ngxp/rest';
import { Observable, tap } from 'rxjs';
import { isLoaded, ListResource, StateResource } from '../resource/resource.util';
import { API_SERVICE, ApiBasedService } from './api-based.service';
import { AbstractFormService } from './formservice.abstract';

@Injectable()
export abstract class ApiFormService<T extends Resource, R> extends AbstractFormService<T> {
  private readonly service: ApiBasedService<T, T, Resource, ListResource, T, R> =
    inject<ApiBasedService<T, T, Resource, ListResource, T, R>>(API_SERVICE);

  doSubmit(): Observable<StateResource<T>> {
    if (this.isPatch()) {
      return this.service.save(this.getFormValue());
    }
    return this.service.create(this.getFormValue());
  }

  public get(): Observable<StateResource<T>> {
    return this.service.get().pipe(
      tap((stateResource: StateResource<T>) => {
        if (isLoaded(stateResource)) this.patch(stateResource.resource);
      }),
    );
  }
}
